export default __webpack_public_path__ + "static/media/img1.5934dd4d.jpg";